<template>
  <div>
    <mdb-pagination class="justify-content-center">
      <mdb-page-nav v-if="pageInfo.page != 1" prev
        @click.native="movePrev()"></mdb-page-nav>
      <mdb-page-item v-for="page in pageInfo.totalPage" :key="page"
          :class="{active: page === pageInfo.page}" @click.native="moveToPage(page)">
        {{page}}
      </mdb-page-item>
      <mdb-page-nav v-if="pageInfo.page != pageInfo.totalPage" next
        @click.native="moveNext()"></mdb-page-nav>
    </mdb-pagination>
  </div>
</template>

<script>
import { mdbPagination, mdbPageNav, mdbPageItem } from 'mdbvue';
export default {
  name: 'Pagination',
  components: { mdbPagination, mdbPageNav, mdbPageItem },
  props: ['pageInfo'],
  methods: {
    moveToPage (page) {
      if (page !== this.pageInfo.page) {
        this.$emit('change-page', page);
      }
    },
    movePrev () {
      if (this.pageInfo.page > 1) {
        this.$emit('change-page', this.pageInfo.page - 1);
      }
    },
    moveNext () {
      if (this.pageInfo.page < this.pageInfo.totalPage) {
        this.$emit('change-page', this.pageInfo.page + 1);
      }
    }
  }
}
</script>
